export const theme = {
  colors: {
    blue: '#00A3FF',
    blueDark: '#0066CC',
    purple: '#6B00FF',
    magenta: '#C800FF',
    dark: '#02020E',
    darker: '#000008',
    mid: '#080818',
    surface: '#0C0C22',
    border: 'rgba(0,163,255,0.12)',
    borderHover: 'rgba(0,163,255,0.35)',
    textPrimary: '#FFFFFF',
    textSecondary: 'rgba(255,255,255,0.82)',
    textMuted: 'rgba(255,255,255,0.55)',
  },
  gradients: {
    brand: 'linear-gradient(135deg, #C800FF 0%, #00A3FF 100%)',
    brandReverse: 'linear-gradient(135deg, #00A3FF 0%, #C800FF 100%)',
    blueGlow: 'radial-gradient(ellipse at center, rgba(0,163,255,0.2) 0%, transparent 70%)',
    heroOverlay: `
      radial-gradient(ellipse 70% 60% at 50% 20%, rgba(107,0,255,0.18) 0%, transparent 70%),
      radial-gradient(ellipse 50% 40% at 15% 80%, rgba(0,163,255,0.12) 0%, transparent 60%),
      radial-gradient(ellipse 60% 50% at 85% 70%, rgba(200,0,255,0.1) 0%, transparent 60%)
    `,
    surface: 'linear-gradient(135deg, rgba(0,163,255,0.06) 0%, rgba(107,0,255,0.06) 100%)',
  },
  fonts: {
    display: "'Bebas Neue', sans-serif",
    heading: "'Orbitron', monospace",
    body: "'Rajdhani', sans-serif",
    mono: "'Space Mono', monospace",
  },
  shadows: {
    blueGlow: '0 0 40px rgba(0,163,255,0.35)',
    magentaGlow: '0 0 40px rgba(200,0,255,0.3)',
    card: '0 20px 60px rgba(0,0,0,0.5)',
    cardHover: '0 30px 80px rgba(0,163,255,0.15)',
  },
};
